import React from "react"
import People from "./People"
import Button from "./Button"
import IconCheck from "./icons/IconCheck"
import cx from "classnames"

import ProgressBar from "./ProgressBar"
import { addParam } from "./History"
import { formatMissionPeople } from "./MissionUtils"
import { displayRole } from "./Utils"
import DotIcon from "./DotIcon"

class ActionTile extends React.PureComponent {
    render() {
        if (!this.props.missionData) return null

        const cn = cx("dna-action-tile", this.props.className, {
            "dna-action-done": this.props.status === "done",
            "dna-always-msg": this.props.alwaysBlue,
            "no-progress": !this.props.progress,
        })

        const actionItems = this.props.actionItems || []

        const progress = (actionItems.filter((item) => item.status === "done").length / actionItems.length) * 100

        let people = []

        if (this.props.type !== "invite" && this.props.people) {
            people = formatMissionPeople(this.props.people)
        } else if (this.props.type === "invite") {
            people = [{ ...this.props.people[0], ref: this.props.people[0] }]
        }

        if (this.props.orgData && this.props.orgData.roles && this.props.orgData.roles.length) {
            people = people.map((p) => {
                return {
                    ...p,
                    role: displayRole(p.role, this.props.orgData),
                }
            })
        }

        let title =
            this.props.title === "Complete" && this.props.source === "ai"
                ? "Complete " + this.props.actionData.title
                : this.props.title

        return (
            <div id={"act-tile-" + this.props._id} className={cn} onClick={(e) => this.props.onClick(this.props, e)}>
                <div className="dna-tile-content">
                    {this.props.openMission && (
                        <label className="atile-m-title" onClick={() => addParam(this.props.missionData.id)}>
                            {this.props.missionData.title}
                        </label>
                    )}
                    {this.props.showMissionTitle && (
                        <label className="atile-m-title">{this.props.missionData.title}</label>
                    )}
                    <h3 className="x-clamp-2">{title}</h3>

                    {this.props.comp && this.props.comp}

                    {this.props.msg && <div className="dna-action-tile-msg">{this.props.msg}</div>}

                    <div className="dna-action-tile-icon">
                        <DotIcon shape={this.props.icon} color={this.props.iconColor} size={96} seed={this.props._id} />
                    </div>

                    {this.props.status === "done" && this.props.type !== "invite" && (
                        <IconCheck width={32} height={30} />
                    )}

                    {actionItems.length === 1 &&
                        this.props.status !== "done" &&
                        this.props.type !== "invite" &&
                        !this.props.from === "ai" && (
                            <Button
                                onClick={(e) => {
                                    e.stopPropagation()
                                    e.preventDefault()
                                    addParam("complete-action", this.props._id)
                                }}
                            >
                                Done
                            </Button>
                        )}
                    {!(people.length === 1 && !people[0].ref?.avatar) && !this.props.noPeople && (
                        <People data={people} />
                    )}

                    {this.props.progress && (
                        <ProgressBar
                            width={progress || 2}
                            label={
                                actionItems.filter((item) => item.status === "done").length + " / " + actionItems.length
                            }
                        />
                    )}
                </div>
            </div>
        )
    }
}

ActionTile.displayName = "ActionTile"
export default ActionTile
